import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { Box } from '../../components/Box'
import { Button } from '../../components/Button'
import { Flex } from '../../components/Flex'
import { Space } from '../../components/Space'
import { Text } from '../../components/Text'
import { ProfileManagementActions } from '../../redux/account/profile-management/actions'
import { createTFunction } from '../../utils/helpers'

const Wrapper = styled(Flex)`
  border-radius: 4px;
`

export const GenerateInvitationLink = () => {
  const { t } = useTranslation('account')
  const tt = createTFunction('account:ProfileManagement.', t)
  const dispatch = useDispatch()
  const handleGenerateInvitationLink = () => {
    dispatch(ProfileManagementActions.openDialogToInvitationLinkGeneration())
  }

  return (
    <Wrapper backgroundColor="primary" flexWrap="wrap" px="24px" py="20px">
      <Box width={[1, 2 / 3, 2 / 3]}>
        <Space direction="vertical" flexDirection="column" space={1}>
          <Text block color="white" fontSize="12px">
            {tt('CreateInvitationLinkText1')}
          </Text>
          <Text block color="white" fontSize="12px">
            {tt('CreateInvitationLinkText2')}
          </Text>
        </Space>
      </Box>
      <Box pl={[0, 0, '20px']} mt={['20px', 0, 0]} width={[1, 1 / 3, 1 / 3]} display="flex" alignItems="center">
        <Button block variant="default" onClick={handleGenerateInvitationLink}>
          {t('account:ProfileManagement.GenerateInvitationLink')}
        </Button>
      </Box>
    </Wrapper>
  )
}
